import { useTranslation } from "react-i18next";
import { QueryClient, QueryClientProvider, useQuery } from "react-query";
import AJXLoader from "@components/AJXLoader";
import LoadError from "@components/LoadError";
import { apiSend, getRoute } from "@services/axios";
import { useParams } from "react-router-dom";
import React from "react";
import LoadComponent from "./components/LoadComponent";

const queryClient = new QueryClient();

const LoadProduct = (props) => {
  const { t } = useTranslation();
  const id = useParams().id;
  const { isLoading, error, data } = useQuery("repoData", () =>
    apiSend([getRoute("PRODUCT_RETRIEVE"), id].join("/"), "get")
  );
  if (isLoading) return <AJXLoader />;
  if (error) return <LoadError message={t("not_found")} />;
  if (data?.data?.request?.status !== true) {
    return <LoadError message={t("not_found")} />;
  }
  const product = data?.data?.result;

  return (
    <>
      <LoadComponent product={product} {...props} />
    </>
  );
};
const Details = (props) => {
  return (
    <QueryClientProvider client={queryClient}>
      <LoadProduct {...props} />
    </QueryClientProvider>
  );
};

export default Details;
